import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import { ApplicationFormStateContextProvider } from "./state/applicationFormState";
import AmountStep from "./pages/steps/Amount";
import OtherAmountStep from "./pages/steps/OtherAmount";
import PeriodOfRepaymentStep from "./pages/steps/PeriodOfRepayment";
import Layout from "./components/Layout";
import ContactInfoStep from "./pages/steps/ContactInfo";
import PurposeStep from "./pages/steps/Purpose";
import MaritalStatusStep from "./pages/steps/MaritalStatus";
import ChildrenStep from "./pages/steps/Children";
import HasCoApplicantStep from "./pages/steps/HasCoApplicant";
import CoApplicantStep from "./pages/steps/CoApplicantStep";
import CoApplicantIncomeStep from "./pages/steps/CoApplicantIncome";
import AccomodationTypeStep from "./pages/steps/AccomodationType";
import HabitationYearStep from "./pages/steps/HabitationYear";
import CitizenshipStep from "./pages/steps/Citizenship";
import PersonalInformationStep from "./pages/steps/PersonalInformation";
import CitizenshipNonDanishStep from "./pages/steps/CitizenshipNonDanish";
import EmploymentStep from "./pages/steps/Employment";
import IncomeStep from "./pages/steps/Income";
import ExpensesStep from "./pages/steps/Expenses";
import CardsStep from "./pages/steps/Cards";
import PayoutStep from "./pages/steps/Payout";
import WantConsolidateLoanStep from "./pages/steps/WantConsolidateLoan";
import ConsolidateLoanStep from "./pages/steps/ConsolidateLoan";
import ConditionsStep from "./pages/steps/Conditions";
import StatusAndQuoteStep from "./pages/steps/StatusAndQuote";
import CookiePage from "./pages/Cookie";


const App: React.FC = () => {
  

  return (
    <Router>
      <ApplicationFormStateContextProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<AmountStep />} />
            <Route path="/andet-beloeb" element={<OtherAmountStep />} />
            <Route path="/produkt/:amount" element={<PeriodOfRepaymentStep />} />
            <Route path="/kunde" element={<ContactInfoStep />} />
            {/* <Route path="/formaal" element={<PurposeStep />} /> */}
            <Route path="/civilstatus" element={<MaritalStatusStep />} />
            <Route path="/boern" element={<ChildrenStep />} />
            <Route path="/tilfoej-medansoeger" element={<HasCoApplicantStep />} />
            <Route path="/medansoeger" element={<CoApplicantStep />} />
            <Route path="/medansoeger-oekonomi" element={<CoApplicantIncomeStep />} />
            <Route path="/boligform" element={<AccomodationTypeStep />} />
            <Route path="/bolig-indflytning" element={<HabitationYearStep />} />
            <Route path="/statsborgerskab" element={<CitizenshipStep />} />
            <Route path="/personinformation" element={<PersonalInformationStep />} />
            <Route path="/andet-statsborgerskab" element={<CitizenshipNonDanishStep />} />
            <Route path="/ansaettelses-forhold" element={<EmploymentStep />} />
            <Route path="/indkomst" element={<IncomeStep />} />
            <Route path="/udgifter" element={<ExpensesStep />} />
            <Route path="/kreditkort" element={<CardsStep />} />
            <Route path="/betaling" element={<PayoutStep />} />
            {/* <Route path="/oensker-samle-laan" element={<WantConsolidateLoanStep />} /> */}
            {/* <Route path="/samle-laan" element={<ConsolidateLoanStep />} /> */}
            <Route path="/betingelser" element={<ConditionsStep />} />
            <Route path="/status" element={<StatusAndQuoteStep />} />
            <Route path="/privatlivspolitik" element={<CookiePage />} />
          </Routes>
        </Layout>
      </ApplicationFormStateContextProvider>
    </Router>
  );
};

export default App;
